<script setup lang="ts">

// DAY-37: only for users whose roles allow it (same permission the API checks)
definePage({
  meta: {
    action: 'read',
    subject: 'CarePlans',
  },
})
const { t } = useI18n()
</script>

<template>
  <section>
    <VCard>
      <VCardTitle class="pa-6">
        {{ t('Programs') }}
      </VCardTitle>
      <VCardText>
        <p class="text-body-1 text-disabled">
          {{ t('Programs content coming soon.') }}
        </p>
      </VCardText>
    </VCard>
  </section>
</template>
